namespace TabAurous.OMS {
    export interface CustomerOrderForm {
        PartyTypeId: Serenity.IntegerEditor;
        PartyType: Serenity.StringEditor;
        PartyCode: Serenity.StringEditor;
        LedgerName: Serenity.StringEditor;
        AccountGroupId: Serenity.DecimalEditor;
        TermId: Serenity.IntegerEditor;
        MailingName: Serenity.StringEditor;
        BillbyBill: Serenity.BooleanEditor;
        IsDisabled: Serenity.BooleanEditor;
        TaxRegType: Serenity.StringEditor;
        GstVat: Serenity.StringEditor;
        Pan: Serenity.StringEditor;
        Tds: Serenity.StringEditor;
        DefaultTdsType: Serenity.StringEditor;
        Tan: Serenity.StringEditor;
        LbrFlag: Serenity.StringEditor;
        StnFlag: Serenity.StringEditor;
        LbrFromDate: Serenity.DateEditor;
        LbrToDate: Serenity.DateEditor;
        LbrPricegroupId: Serenity.IntegerEditor;
        LbrAddDisc: Serenity.DecimalEditor;
        LbrAddMkp: Serenity.DecimalEditor;
        StnFromDate: Serenity.DateEditor;
        StnToDate: Serenity.DateEditor;
        CostPricegroupId: Serenity.IntegerEditor;
        StnAddDisc: Serenity.DecimalEditor;
        StnAddMkp: Serenity.DecimalEditor;
    }

    export class CustomerOrderForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.CustomerOrder';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CustomerOrderForm.init)  {
                CustomerOrderForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.DateEditor;

                Q.initFormType(CustomerOrderForm, [
                    'PartyTypeId', w0,
                    'PartyType', w1,
                    'PartyCode', w1,
                    'LedgerName', w1,
                    'AccountGroupId', w2,
                    'TermId', w0,
                    'MailingName', w1,
                    'BillbyBill', w3,
                    'IsDisabled', w3,
                    'TaxRegType', w1,
                    'GstVat', w1,
                    'Pan', w1,
                    'Tds', w1,
                    'DefaultTdsType', w1,
                    'Tan', w1,
                    'LbrFlag', w1,
                    'StnFlag', w1,
                    'LbrFromDate', w4,
                    'LbrToDate', w4,
                    'LbrPricegroupId', w0,
                    'LbrAddDisc', w2,
                    'LbrAddMkp', w2,
                    'StnFromDate', w4,
                    'StnToDate', w4,
                    'CostPricegroupId', w0,
                    'StnAddDisc', w2,
                    'StnAddMkp', w2
                ]);
            }
        }
    }
}
